import type {
  HttpErrorResponse,
  HttpInterceptorFn,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { environment } from '@env';
import { catchError, throwError } from 'rxjs';
import { AuthService } from './auth.service';

export const tokenInterceptor: HttpInterceptorFn = (request, next) => {
  // Only intercept requests to our API
  const baseUrl = environment.apiUrl;
  if (!request.url.startsWith(baseUrl)) {
    return next(request);
  }

  const auth = inject(AuthService);
  const token = auth.token();

  let authRequest = request;
  if (token) {
    authRequest = request.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
      },
    });
  }

  return next(authRequest).pipe(
    catchError((error: HttpErrorResponse) => {
      if (token && error.status === 401) {
        auth.logout();
      }
      return throwError(() => error);
    }),
  );
};
